"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["EN"] = "en-US";
    SupportedLanguages["FR"] = "fr-CA";
    SupportedLanguages["ES"] = "es";
})(SupportedLanguages = exports.SupportedLanguages || (exports.SupportedLanguages = {}));
exports.LanguageInitMap = {
    englishStrings: SupportedLanguages.EN,
    frenchStrings: SupportedLanguages.FR,
    spanishStrings: SupportedLanguages.ES,
};
